import React = require('react');
import { AdmiralCardAnswer } from '../../../Components/AdmiralCardAnswer';
import { Col, Row } from 'react-bootstrap';
import { Field, InjectedFormProps } from 'redux-form';
import { isRequired } from '../../../../../../util/validators';
import { ButtonAsRadio } from '../../../../../../components/ButtonRadioStyle';
import { useEffect, useState } from 'react';
import { forEach, isNull } from 'lodash';
import { MedicalInfoModal } from './MedicalInfoModal';
import { IProduct } from '../../../../../../data/api/models';
import { FaInfoCircle } from 'react-icons/fa';

interface IMedicalHistoryProps extends InjectedFormProps {
  medicalHistory: boolean;
  synchronousError: any;
  product: IProduct;
  medicalDeclaration: any[];
}


export const MedicalHistory = ({
                                 change,
                                 synchronousError,
                                 medicalHistory,
                                 product,
                                 medicalDeclaration
                               }: IMedicalHistoryProps) => {

  const [editable, setEditable] = useState(true);
  const [showInfoModal, setShowInfoModal] = useState(false);

  useEffect(() => {
    if (!isNull(medicalHistory) && medicalHistory !== undefined) {
      setEditable(false)
    }
  }, [medicalHistory]);

  const onChangeEdit = (isEditable) => {
    setEditable(isEditable)
    if (isEditable) {
      setMedicalDeclarationAnswers(null)
    }
    change('medicalHistory', null);
  }

  let answered = false;

  if (typeof medicalHistory === 'boolean') {
    answered = true;
  }

  const handleAnswerChange = (answer) => {
    if (answer) {
      setMedicalDeclarationAnswers(false)
    }
    setEditable(false)
  }

  const setMedicalDeclarationAnswers = (value) => {
    forEach(medicalDeclaration, (declarationValue, key) => {
      declarationValue.answer = value;
      change(`medicalDeclaration.${key}`, declarationValue)
    })
  }

  const content = () => {

    const icon = answered ? (
      <img height={'20px'} style={{ marginRight: '10px' }} src={require('../../../../img/green-tick.svg')}
           alt={'Admiral'}/>) : '';

    return (
      <>
        <Row>
          <Col xs={12} style={{ marginBottom: '10px' }}><strong>All named travellers:</strong></Col>
          <Col xs={12}>
            <div>
              <div style={{ display: 'flex' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Are not currently on a waiting list for treatment or investigation</div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Have not been diagnosed with a terminal condition</div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Have never been diagnosed with any heart or respiratory condition, any circulatory condition (such
                  as
                  blood flow, strokes, high blood pressure, cholesterol), any liver condition or any cancerous
                  condition?
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Have not been prescribed medication, received treatment or had a consultation with a medical
                  professional for any condition in the past 2 years?
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Have never been diagnosed with or treated for any psychological or psychiatric conditions (such as
                  stress, anxiety, depression, eating disorders or mental instability)
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} style={{ marginTop: '10px' }}><strong>Are all of these statements true?</strong></Col>
        </Row>
        {medicalHistory === null && (
          <Row style={{ border: '1px solid #a2a2a2' }}>
            <Col xs={12} style={{ marginTop: '10px' }}><strong>Please select No if:</strong></Col>
            <Col xs={12}>
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <div style={icon ? { paddingRight: '5px' } : { display: 'list-item', marginLeft: '25px' }}>{icon}</div>
                <div>Any of these statements are not true for any traveller named on the policy.</div>
              </div>
              <div style={{ display: 'flex', margin: '10px 0 10px 0' }}>
                <div style={icon ? { paddingRight: '5px', marginTop: '10px' } : {
                  display: 'list-item',
                  marginLeft: '25px'
                }}>{icon}</div>
                <div>You wish to declare a medical condition for a traveller named on the policy.</div>
              </div>
            </Col>
          </Row>
        )}
        {medicalHistory === false && (
          <Row style={{ border: '1px solid #a2a2a2', padding: '10px 0' }}>
            <Col xs={12}>Please click Continue to progress to the medical screening page,
              where you can add the medical conditions for travellers named on the policy.</Col>
          </Row>
        )}
      </>

    )
  }

  const renderButtons = () => {
    return (
      <>
        <div className={'button-container'}>
          <div className={'box--half'}>
            <Field
              name={'medicalHistory'}
              simpleValue={true}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn'}
              selectedText={'YES'}
              unSelectedText={'YES'}
              isBlock={true}
              validate={[isRequired]}
              component={ButtonAsRadio}
              handleChange={handleAnswerChange}
            />
          </div>
          <div className={'box--half'}>
            <Field
              name={'medicalHistory'}
              simpleValue={false}
              className={'admiral-yes-no-answer-btn'}
              secondaryClass={'admiral-yes-no-answer-btn'}
              selectedText={'NO'}
              unSelectedText={'NO'}
              isBlock={true}
              validate={[isRequired]}
              component={ButtonAsRadio}
              handleChange={handleAnswerChange}
            />
          </div>
        </div>
      </>
    )
  }

  const showModal = () => {
    setShowInfoModal(true)
  }

  const closeModal = () => {
    setShowInfoModal(false)
  }

  const infoModal = () => {
    return (
      <>
        <div onClick={showModal} style={{ cursor: 'pointer' }}><FaInfoCircle className="info-btn"/></div>
        <MedicalInfoModal showDeclineModal={showInfoModal} onCloseModal={closeModal} product={product}/>
      </>
    )
  }

  return (
    <>
      <AdmiralCardAnswer
        icon={'quote-summary.svg'}
        title={'Medical history'}
        editMode={editable}
        infoModal={infoModal()}
        handleEdit={onChangeEdit}
        answerSelected={medicalHistory}
        approvedPositiveText={'Yes, all statements are true'}
        approvedNegativeText={'No, some statements are not true'}
        infoText={'Please check these important statements about medical history.'}
        shouldAcceptNoAsPositive={true}
        infoTextSuccess={'You\'ve checked these important statements about about medical history.'}
      >
        {content()}
      </AdmiralCardAnswer>
      <div style={{ backgroundColor: '#FFFFFF' }}>
        {editable && renderButtons()}
      </div>
    </>
  )
}
